import io from "socket.io-client";
import { API_BASE_URL } from "../../config";
import { attachViewerCoinPoolEntries, getLocalDayBounds } from "../utils/coinPoolHelpers";
import { selectAppUser } from "./appAuthSlice";
import {
  fetchCoinPoolConstants,
  fetchCoinPoolCurrentRound,
  fetchCoinPoolHistory,
  setCoinPoolLastResult,
  setCoinPoolRound,
} from "./coinPoolSlice";

let socket = null;
let initialized = false;

export const initCoinPoolSocket = (dispatch) => {
  if (initialized && socket?.connected) return socket;
  initialized = true;

  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 30000,
      upgrade: false,
      forceNew: false,
      withCredentials: false,
    });
  }

  socket.off("connect");
  socket.off("coin-pool:round:update");

  socket.on("connect", () => {
    socket.emit("coin-pool:subscribe", {}, () => {});
    dispatch(fetchCoinPoolCurrentRound());
  });

  socket.on("coin-pool:round:update", (round) => {
    if (!round) return;
    dispatch((innerDispatch, getState) => {
      const userId = selectAppUser(getState())?._id;
      const enriched = attachViewerCoinPoolEntries(round, userId);
      innerDispatch(setCoinPoolRound(enriched));
      if (enriched.status === "complete") {
        innerDispatch(setCoinPoolLastResult(enriched));
        innerDispatch(fetchCoinPoolHistory({ limit: 6, ...getLocalDayBounds() }));
      }
    });
  });

  if (!socket.connected) socket.connect();
  dispatch(fetchCoinPoolCurrentRound());
  dispatch(fetchCoinPoolConstants());
  return socket;
};
